import { GLOBAL_TABLE_PAGE_SIZE, GLOBAL_TABLE_SIZE, GLOBAL_TABLE_YSCROLL } from 'global_config/constant-global';
import errorMessage from 'global_config/error_messages';

export const moduleTitle = 'EXAM RESULT';
export const drawerTitle = {
	add: "ADD EXAM RESULT",
	update: "UPDATE EXAM RESULT"
}

export const tablePageSize = GLOBAL_TABLE_PAGE_SIZE;
export const tableSize = GLOBAL_TABLE_SIZE;
export const tableYScroll = GLOBAL_TABLE_YSCROLL;

export const buttonNames = {
	addExamItem: 'ADD EXAM RESULT',
	cancel: 'CANCEL',
	create: 'ADD',
	addField: 'ADD FIELD',
	update: 'UPDATE'
}

export const messagePrompts = {
	successCreatedExamItems: 'Exam result successfully created.',
	successUpdatedExamItems: 'Exam result successfully updated.'
}

export const fieldRules = {
	examItemName: [
		{ required: true, message: errorMessage.required },
		// { type: 'number', message: '' },
		{ max: 200, message: errorMessage.maxLength(200) }
	],
	examItemGeneralName: [
		{ required: true, message: errorMessage.required },
		{ max: 50, message: errorMessage.maxLength(50) }
	],
	examItemType: [
		{ required: true, message: errorMessage.required }
	],
	examItemTypeDefault: [
		// { max: 254, message: errorMessage.maxLength(254) }
	],
	unitOfMeasure: [
		// { required: true, message: errorMessage.required }
	],
	integrationCode: [
		{ required: false, message: errorMessage.required },
		{ max: 20, message: errorMessage.maxLength(20) }
	]
};

export const fieldLabels = {
	examItemName: "EXAM RESULT NAME",
	examItemGeneralName: "ALTERNATIVE NAME",
	examItemTypeCode: "EXAM RESULT TYPE",
	examItemUnitCode: "UNIT OF MEASURES",
	examItemTypeDefault: "DEFAULT VALUE",
	examItemIntegrationCode: "INTEGRATION CODE"
}
